<template>
  <div>
    <b-row :style="{marginBottom: '18px'}">
      <b-col>
        <b-button class="float-right" variant="outline-primary" @click="exportItem"><i class="fa fa-download" /> 导出</b-button>
      </b-col>
    </b-row>
    <b-table class="text-center" show-empty responsive="sm" :items="items" :fields="fields" :emptyText="tableEmptyText">
      <template #cell(online)="data">
        <i v-if="!!data.item.online" class="fa fa-check text-success" />
        <i v-else class="fa fa-close text-danger" />
      </template>

      <template #cell(detail)="data">
        <b-button v-if="data.item.vote > 0" variant="link" @click="showDetail(data.item.vote_id)"><i class="fa fa-chevron-right" /></b-button>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      prev-text="<<"
      next-text=">>"
      @change="changePage"
      hide-goto-end-buttons
      first-number
      last-number
    />
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'

export default {
  name: 'item',
  mixins: [Error],
  props: ['appId', 'oversea'],
  data () {
    return {
      tableEmptyText: consts.TABLE_EMPTY_TEXT,
      items: null,
      totalRows: null,
      fields: null,
      currentPage: 1,
      perPage: 10,
      tabName: '投票项统计'
    }
  },
  created () {
    this.getItemInfo()
  },
  methods: {
    changePage (page) {
      this.currentPage = page
      this.getItemInfo()
    },
    getItemInfo () {
      api.fetchVoteListData(this, api.getVoteItemStatistics(), 'item_list', {app_id: this.appId}, this.oversea ? consts.OVERSEA_TYPE : '', this.getFields)
    },
    getFields (resData) {
      this.fields = null
      this.items = resData['item_list']
      this.totalRows = resData.total_num
      if (resData['item_list'].length) {
        let staticFields = JSON.parse(JSON.stringify(consts.VOTE_ITEM_STATISTICS_FIELDS))
        let staticKeys = staticFields.map(i => Object.keys(i)[0])
        staticKeys.sort()
        for (let idx in Object.keys(resData['item_list'][0])) {
          let key = Object.keys(resData['item_list'][0])[idx]
          if (staticKeys.indexOf(key) === -1) {
            let tmp = {}
            tmp[key] = key
            staticFields.push(tmp)
          }
        }
        let tmp = {detail: '详情'}
        staticFields.push(tmp)
        this.fields = staticFields
      }
    },
    showDetail (voteId) {
      this.$emit('hide', {voteId: voteId})
    },
    exportItem () {
      this.$emit('export', {
        path: api.getVoteItemStatisticsExport(),
        tab: this.tabName
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Item.vue?64f2eebd